import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MoreHorizontal, X } from "lucide-react";

export function MobileTabBar({ tabs, primary, active, onPick, extra = [] }) {
  const [more, setMore] = useState(false);
  const nav = useNavigate();
  const main = primary.map((k) => tabs.find((t) => t.k === k)).filter(Boolean).slice(0, 4);
  const rest = [...tabs.filter((t) => !main.includes(t)), ...extra];
  const pick = (t) => { setMore(false); t.to ? nav(t.to) : onPick(t.k); };
  const label = (t) => t.short || t.l || t.label;
  const restActive = rest.some((t) => t.k === active);
  return (
    <>
      {more && (
        <div className="md:hidden fixed inset-0 z-40 bg-black/60 animate-in fade-in duration-200" onClick={() => setMore(false)} data-testid="mtab-more-sheet">
          <div className="absolute bottom-0 inset-x-0 surface border-t border-gold/30 p-4 pb-[calc(5rem+env(safe-area-inset-bottom))] animate-in slide-in-from-bottom-6 duration-300" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center mb-3"><span className="text-[11px] uppercase tracking-widest text-slate-500">More</span><button onClick={() => setMore(false)} className="ml-auto text-slate-400 p-1" data-testid="mtab-more-close"><X size={18} /></button></div>
            <div className="grid grid-cols-3 gap-2">
              {rest.map((t) => (
                <button key={t.k} onClick={() => pick(t)} data-testid={`mtab-more-${t.k}`}
                  className={`flex flex-col items-center gap-1.5 py-3 px-1 border text-[11px] leading-tight text-center transition-colors duration-200 ${active === t.k ? "border-gold text-gold" : "border-[color:var(--border-subtle)] text-slate-300 active:bg-white/5"}`}>
                  <t.icon size={20} className={t.to ? "text-gold" : ""} />{t.l || t.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
      <nav className="md:hidden fixed bottom-0 inset-x-0 z-50 glass border-t border-[color:var(--border-subtle)] pb-[env(safe-area-inset-bottom)]" data-testid="mobile-tab-bar">
        <div className="grid grid-cols-5">
          {main.map((t) => (
            <button key={t.k} onClick={() => pick(t)} data-testid={`mtab-${t.k}`}
              className={`flex flex-col items-center justify-center gap-1 h-16 text-[10px] transition-colors duration-200 ${active === t.k && !more ? "text-gold" : "text-slate-400"}`}>
              <t.icon size={21} strokeWidth={active === t.k ? 2.2 : 1.8} /><span className="truncate max-w-full px-1">{label(t)}</span>
            </button>
          ))}
          <button onClick={() => setMore((m) => !m)} data-testid="mtab-more"
            className={`flex flex-col items-center justify-center gap-1 h-16 text-[10px] transition-colors duration-200 ${more || restActive ? "text-gold" : "text-slate-400"}`}>
            <MoreHorizontal size={21} />More
          </button>
        </div>
      </nav>
    </>
  );
}
